// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"FormGroup_formGroup__jGM4T","slim":"FormGroup_slim__nz75c"};